export default __webpack_public_path__ + "static/APP_3_2-9ea427d725af6b51a5e15814ff6ee106.png";